import React from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import GlobalStyle from "../FixedStyled";
import Home from "../Rootelements/Homepagesubfiles/Home";
import ScrollToTop from "../Rootelements/Homepagesubfiles/Scrolltotop";
import { Navbar, Footer, Pricing } from "../Rootelements/Homepagesubfiles";
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import Slider from "../Rootelements/Homepagesubfiles/Carousel/slider";
import Joingroup from "../Rootelements/Homepagesubfiles/Joingroup/joingroup";
import Questions from "../Rootelements/Homepagesubfiles/freqques/Questions";

function HomePage() {
  return (
    <div>
      <GlobalStyle />
      <ScrollToTop />
      <Navbar />
      <Home />
      <Slider/>
      <Joingroup />
      <Pricing />
      <Questions />
      <Footer />
    </div>
  );
}

export default HomePage;
